webpackJsonp([118514840243029],{

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(423);
	
	var _MainPicture = __webpack_require__(21);
	
	var _MainPicture2 = _interopRequireDefault(_MainPicture);
	
	var _eCommerce = __webpack_require__(791);
	
	var _eCommerce2 = _interopRequireDefault(_eCommerce);
	
	var _sylius = __webpack_require__(818);
	
	var _sylius2 = _interopRequireDefault(_sylius);
	
	var _LeftPictureBackground = __webpack_require__(20);
	
	var _LeftPictureBackground2 = _interopRequireDefault(_LeftPictureBackground);
	
	var _paintRoller = __webpack_require__(808);
	
	var _paintRoller2 = _interopRequireDefault(_paintRoller);
	
	var _D = __webpack_require__(780);
	
	var _D2 = _interopRequireDefault(_D);
	
	var _LeftPicture = __webpack_require__(71);
	
	var _LeftPicture2 = _interopRequireDefault(_LeftPicture);
	
	var _CheckModule = __webpack_require__(32);
	
	var _CheckModule2 = _interopRequireDefault(_CheckModule);
	
	var _jewel = __webpack_require__(800);
	
	var _jewel2 = _interopRequireDefault(_jewel);
	
	var _technologies = __webpack_require__(42);
	
	var _technologies2 = _interopRequireDefault(_technologies);
	
	var _symfony = __webpack_require__(41);
	
	var _symfony2 = _interopRequireDefault(_symfony);
	
	var _nodejs = __webpack_require__(40);
	
	var _nodejs2 = _interopRequireDefault(_nodejs);
	
	var _angularReact = __webpack_require__(37);
	
	var _angularReact2 = _interopRequireDefault(_angularReact);
	
	var _baseDeDonnee = __webpack_require__(38);
	
	var _baseDeDonnee2 = _interopRequireDefault(_baseDeDonnee);
	
	var _elasticsearch = __webpack_require__(67);
	
	var _elasticsearch2 = _interopRequireDefault(_elasticsearch);
	
	var _htmlCssJs = __webpack_require__(39);
	
	var _htmlCssJs2 = _interopRequireDefault(_htmlCssJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ECommerce = function (_Component) {
	  _inherits(ECommerce, _Component);
	
	  function ECommerce() {
	    _classCallCheck(this, ECommerce);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ECommerce.prototype.render = function render() {
	    var alt = "E-Commerce";
	    var description = ["L'E-Commerce B2B ou B2C est un canal de vente exceptionnel qu'il faut traiter comme tel. C'est pourquoi nous proposons la mise en place de ", _react2.default.createElement(
	      "strong",
	      null,
	      "solutions de vente en ligne innovantes"
	    ), " et sur-mesure pour optimiser ce canal de vente comme il se doit !"];
	
	    var smalltitle = "Réunissons nos expertises";
	    var titlemethodo = "Inventons ensemble votre plateforme de vente !";
	    var descriptionmethodo = ["Nous vous accompagnons pour imaginer une solution qui collera parfaitement à votre identité et vos produits tout en étant optimisé pour la vente en ligne."];
	    var pictureMethodo = _paintRoller2.default;
	    var altmethodo = "Méthodologie agile Scrum en image";
	
	    var smalltitleevol = "sublimons vos produits";
	    var titleevol = "Mettre en avant vos produits d'exception !";
	    var descriptionevol = ["nous réalisons des sites E-Commerce qui équilibrent l'exposition de vos produits telles des ", _react2.default.createElement(
	      "strong",
	      null,
	      "oeuvres d'art"
	    ), " avec la force du ", _react2.default.createElement(
	      "strong",
	      null,
	      "E-Marketing"
	    ), ". ", _react2.default.createElement("br", null), _react2.default.createElement("br", null), "Vous souhaitez vendre en ligne des produits inédits ? des produits complexes ? nous vous accompagnons dans toute votre stratégie en ligne !"];
	
	    var altevol = "Intégration du portail dans votre système d'information";
	
	    var smalltitleCheck = "Tous les supports, partout, tout le temps !";
	    var titleCheck = "L'innovation technologique au service du E-Commerce";
	    var subtitle1Check = "Vos produits en 3D";
	    var text1Check = ["Nous réalisons des configurateurs en ligne en vrai 3D compatible PC, Tablette, Smartphone de vos produits."];
	    var subtitle2Check = "La vente sur tous les supports";
	    var text2Check = "Nos applications E-Commerce sont responsives et donc compatibles avec tous les supports comme le téléphone mobile, la tablette tactile ou encore le PC.";
	    var subtitle3Check = "Un configurateur en ligne";
	    var text3Check = ["Vous avez des produits complexes ? Des milliers de variantes possibles ? Vous souhaitez pouvoir générer de nouveaux sites E-Commerce à la volée ? ", _react2.default.createElement(
	      "a",
	      { href: "/contact", title: "Nous contacter" },
	      "N'h\xE9sitez pas \xE0 nous contacter !"
	    )];
	    var pictureCheck = _D2.default;
	    var altCheck = "Le E-Commerce d'excellence";
	
	    var description3 = ["Chez Integral Service nous développons des expériences et solutions", _react2.default.createElement(
	      "strong",
	      null,
	      "E-Commerce"
	    ), " sur-mesure à l'aide de technologies flexibles, innovantes, pérennes, sécurisées et évolutives ! C'est pourquoi nos sites sont développés avec ", _react2.default.createElement(
	      "a",
	      { href: "/expert-symfony", title: "En savoir plus sur Symfony" },
	      "Symfony"
	    ), " et Sylius. Ces technologies nous permettent de créer des solutions clefs en main, connectées, compatibles avec votre système d'information et puissantes."];
	    var altSylius = "Logo officiel de Sylius";
	
	    return _react2.default.createElement(
	      "div",
	      { className: "generic-services" },
	      _react2.default.createElement(_MainPicture2.default, { title: "Un canal de vente exceptionnel", description: description, picture: _eCommerce2.default, alt: alt }),
	      _react2.default.createElement(_LeftPicture2.default, { smalltitle: smalltitleevol, title: titleevol, description: descriptionevol, picture: _jewel2.default, alt: altevol }),
	      _react2.default.createElement(_LeftPictureBackground2.default, { smalltitle: smalltitle, title: titlemethodo, description: descriptionmethodo, picture: pictureMethodo, alt: altmethodo }),
	      _react2.default.createElement(_CheckModule2.default, {
	        smalltitle: smalltitleCheck,
	        title: titleCheck,
	        subtitle1: subtitle1Check,
	        text1: text1Check,
	        subtitle2: subtitle2Check,
	        text2: text2Check,
	        subtitle3: subtitle3Check,
	        text3: text3Check,
	        picture: pictureCheck,
	        alt: altCheck
	      }),
	      _react2.default.createElement(_MainPicture2.default, { title: "Les meilleures technologies pour vos clients", description: description3, picture: _sylius2.default, alt: altSylius })
	    );
	  };
	
	  return ECommerce;
	}(_react.Component);
	
	exports.default = ECommerce;
	module.exports = exports["default"];

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"btn":"src-components-Page----ECommerce-module---btn---2VmR7","btn-primary":"src-components-Page----ECommerce-module---btn-primary---3zYQq","btn-wrap-pre":"src-components-Page----ECommerce-module---btn-wrap-pre---pW3XE"};

/***/ }),

/***/ 780:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/3D.61682081.png";

/***/ }),

/***/ 791:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/e-commerce.417e5742.png";

/***/ }),

/***/ 800:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/paint-roller.512a426f.png";

/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sylius.ac4ac094.png";

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(12);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SocialLinks = __webpack_require__(16);
	
	var _SocialLinks2 = _interopRequireDefault(_SocialLinks);
	
	var _SEO = __webpack_require__(14);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _ECommerce = __webpack_require__(289);
	
	var _ECommerce2 = _interopRequireDefault(_ECommerce);
	
	var _HeaderPage = __webpack_require__(15);
	
	var _HeaderPage2 = _interopRequireDefault(_HeaderPage);
	
	var _Menu = __webpack_require__(13);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Footer = __webpack_require__(11);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _iot = __webpack_require__(181);
	
	var _iot2 = _interopRequireDefault(_iot);
	
	var _SiteConfig = __webpack_require__(6);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Contact = __webpack_require__(19);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	__webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ECommerceApp = function (_Component) {
	    _inherits(ECommerceApp, _Component);
	
	    function ECommerceApp() {
	        _classCallCheck(this, ECommerceApp);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ECommerceApp.prototype.render = function render() {
	        // SEO PURPOSES
	        var slug = this.props.pathContext.slug;
	
	
	        var postNode = {
	            "frontmatter": {
	                "title": "Création de site E-Commerce BtoB/BtoC",
	                "description": "Integral Service réalise, pour vous, d'incroyables sites E-Commerce, rapides et efficaces, en adéquation avec votre stratégie de vente en ligne !",
	                "cover": _iot2.default
	            }
	        };
	
	        var title = "E-Commerce sur-mesure";
	        var description = "Des sites E-Commerce B2B/ B2C inédits !";
	        var goto = "En découvrir plus";
	
	        return _react2.default.createElement(
	            "div",
	            { className: "webapp-container page-details" },
	            _react2.default.createElement(_Header2.default, null),
	            _react2.default.createElement(_Menu2.default, null),
	            _react2.default.createElement(_reactHelmet2.default, {
	                title: "Cr\xE9ation de site E-Commerce BtoB/BtoC | " + _SiteConfig2.default.siteTitle,
	                description: "Integral Service r\xE9alise, pour vous, d'incroyables sites E-Commerce, rapides et efficaces, en ad\xE9quation avec votre strat\xE9gie de vente en ligne !"
	            }),
	            _react2.default.createElement(_SEO2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	            _react2.default.createElement(_HeaderPage2.default, { title: title, description: description, picture: _iot2.default }),
	            _react2.default.createElement(_ECommerce2.default, null),
	            _react2.default.createElement(_Contact2.default, null),
	            _react2.default.createElement(_SocialLinks2.default, { postPath: slug, postNode: postNode }),
	            _react2.default.createElement(_Footer2.default, null)
	        );
	    };
	
	    return ECommerceApp;
	}(_react.Component);
	
	exports.default = ECommerceApp;
	
	;
	module.exports = exports["default"];

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/iot.f0f42b3a.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-e-commerce-jsx-17bdf8bda09bdf3c66d2.js